import { useContext } from "react";
import { PricePerHourContext } from "../contexts/PricePerHourContext";

export const usePricePerHour = () => {
  return useContext(PricePerHourContext);
};
